import axios from "axios";
import env from "../variables/EndpointEnvironment";
const headers = {
  "Content-Language": localStorage.getItem('i18nextLng'),
}
const CareerAPI = (props) => {
  return axios.get(
    `${env.HOST}/karir/${props}`,
    {
      headers
    }
  );
};
export default CareerAPI;
